<template>
  <div>
    <form>
      <div class="form-group">
        <label class="form-label col-label required">{{
          $t('healthItem.healthcategory')
        }}</label>
        <select
          class="form-control"
          v-model="model.health_category_id"
          :class="{ 'is-invalid': errors.has('health_category_id') }"
        >
          <option value="" disabled selected style="display: none">
            {{ $t('Select') }}
          </option>
          <option
            v-for="(category, index) in categories"
            :key="index"
            :value="category.health_category_id"
          >
            {{ category.health_category_description }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('health_category_id')">
          {{ errors.first('health_category_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="form-label col-label required">{{
          $t('healthItem.healthItemDescription')
        }}</label>
        <input
          v-model="model.health_item_description"
          type="text"
          class="form-control"
          :placeholder="$t('healthItem.healthItemDescription')"
          :class="{ 'is-invalid': errors.has('health_item_description') }"
        />
        <div
          class="invalid-feedback"
          v-if="errors.has('health_item_description')"
        >
          {{ errors.first('health_item_description') }}
        </div>
      </div>
      <div class="form-group">
        <label class="form-label col-label">{{
          $t('healthItem.healthItemDescriptionKh')
        }}</label>
        <input
          v-model="model.health_item_description_kh"
          type="text"
          class="form-control"
          :placeholder="$t('healthItem.healthItemDescriptionKh')"
        />
      </div>
      <div class="form-group">
        <ts-checkbox v-model="model.has_comment">{{
          $t('healthItem.hasComment')
        }}</ts-checkbox>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'health-item-form-create',
  props: ['edit'],
  data () {
    return {
      model: {
        health_category_id: '',
        health_item_description: '',
        health_item_description_kh: '',
        has_comment: false
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  created () {
    this.setEdit()
    this.getCategory()
  },
  computed: {
    ...mapState('healthItem', ['categories'])
  },
  methods: {
    ...mapActions('healthItem', ['getCategory']),
    async save () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'healthItem/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },
    async update () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'healthItem/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'health-item' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },
    setEdit () {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm () {
      this.model.health_category_id = ''
      this.model.health_item_description = ''
      ;(this.model.health_item_description_kh = ''),
        (this.model.has_comment = false)
    },
    cancel () {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'health-item' })
    }
  },
  watch: {
    edit: {
      handler () {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
